var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24511 1.13462C4.52365 1.10782 4.80373 1.16665 5.04795 1.30324L5.05353 1.30636L18.1751 8.79269C18.3877 8.91153 18.565 9.08474 18.6887 9.29464C18.8135 9.50622 18.8793 9.74736 18.8793 9.99297C18.8793 10.2386 18.8135 10.4797 18.6887 10.6913C18.5651 10.9011 18.3879 11.0742 18.1754 11.193L5.05008 18.7003C4.80513 18.8383 4.52372 18.8979 4.24382 18.8711C3.96392 18.8443 3.69898 18.7323 3.4847 18.5502C3.27041 18.3682 3.1171 18.1248 3.04543 17.8529C2.97471 17.5847 2.98681 17.3014 3.07998 17.0403L5.45818 10L3.07919 2.95816C2.98749 2.69657 2.97698 2.41332 3.04912 2.14556C3.12193 1.87537 3.27543 1.63383 3.48914 1.45319C3.70284 1.27255 3.96657 1.16141 4.24511 1.13462ZM6.78811 10.75L4.59909 17.2302L17.2522 9.9931L4.60057 2.77492L6.78809 9.25H11.2498C11.664 9.25 11.9998 9.58579 11.9998 10C11.9998 10.4142 11.664 10.75 11.2498 10.75H6.78811Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.b63c15bf8f6690fc20c55c61473efce9.svg";
export { ForwardRef as ReactComponent };